module.exports = __webpack_public_path__ + "assets/loyalty-promotion-notification.b52fa265.svg";